/**
 * Whether the stored ABN verdict demands admin attention. Only a definitive
 * 'invalid' (registry says cancelled / not found) qualifies — 'unverified'
 * means the registry was never reached and is styled neutrally elsewhere.
 */
export function abnNeedsAction(
  status: 'unverified' | 'verified' | 'invalid' | null | undefined,
): boolean {
  return status === 'invalid';
}
